import { useState } from "react";

import {
    AnalyticsAttributesProvider,
    Modal,
    ModalTrigger,
    useAnalytics,
    useAnalyticsAttributes
} from "../../components";
import { UiModalModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

export type UiModalProps = {
    readonly model: UiModalModel;
};

const UiModal = ({ model }: UiModalProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { id, content } = model;
    const {
        entryTitle,
        title,
        transitionType,
        transitionSpeed,
        modalSize,
        closeText,
        modalContent
    } = content;
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (
        <AnalyticsAttributesProvider
            value={{
                eventColumn: title,
                eventContainer: model.type,
                labelEnglish: entryTitle
            }}
        >
            <ModalTrigger
                data-testid="ui-modal-trigger"
                onClick={() => {
                    setIsOpen(true);
                    sendTrackEvent("modalOpened", {
                        ...analyticsAttributes,
                        event: "opened",
                        eventComponent: model.type,
                        label: title,
                        labelEnglish: entryTitle,
                        title,
                        uuid: model.id
                    });
                }}
                as={model.content.modalTriggerBlock ? "div" : "span"}
            >
                {renderViewModel(model.content.modalTrigger)}
            </ModalTrigger>
            <Modal
                modal={{
                    id,
                    content: {
                        transitionType,
                        transitionSpeed,
                        modalSize,
                        closeText
                    }
                }}
                isOpen={isOpen}
                close={() => {
                    setIsOpen(false);
                    sendTrackEvent("modalClosed", {
                        ...analyticsAttributes,
                        event: "closed",
                        eventComponent: model.type,
                        label: title,
                        labelEnglish: entryTitle,
                        title,
                        uuid: model.id
                    });
                }}
            >
                {renderViewModel(modalContent)}
            </Modal>
        </AnalyticsAttributesProvider>
    );
};

export default UiModal;
